module.exports = __webpack_public_path__ + "static/media/selectedDragAndDropHover.039919a1.png";